<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main v-loading="isCropping">
        <div style="padding-bottom: 1rem;">
            <el-text>建了一个用于提问/反馈问题/收集优化建议的群：1067275226，也欢迎在群里返图/等候更新发布，这会让我有更多的动力:3</el-text><br>
            <el-text>标记尺使用教程/更新日志在最下方↓</el-text><br>
        </div>
        <div style="padding-bottom: 2rem;">
            <el-button type="primary" @click="drawerVisible = true">添加人物(手机端)</el-button>
        </div>
        <el-dialog v-model="captureVisible" style="width:100%;height:auto;" title="请右键或长按保存截图">
            <img id="captureResult" style="width:100%">
        </el-dialog>
        <el-dialog v-model="currentImageVisible"><img style="width:100%" :src="currentImage[0].url"
                alt="预览图" /></el-dialog>
        <el-dialog v-model="editVisible">
            <h2 class="section-title">编辑人物</h2>
            <el-form :model="editForm" class="mb-4">
                <el-row :gutter="10" class="mb-4">
                    <el-col :xs="24" :sm="24">
                        <el-input v-model="editForm.name" placeholder="姓名" clearable
                            @input="validateEditForm"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="24">
                        <el-input v-model.number="editForm.height" type="number" min="50" max="250" placeholder="身高（cm）"
                            clearable @input="validateEditForm"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="24" style="padding-top: 1rem;">
                        <el-button type="default" @click="handleAdvanced">进阶选项</el-button>
                        <el-text style="padding-left: 0.5rem;">注：进阶选项均为非必选项</el-text>
                    </el-col>
                    <el-col :xs="24" :sm="24" v-show="advanced">
                        <el-input v-model.number="editForm.gap" type="number" min="50" max="250" placeholder="左间距（px）"
                            clearable @input="validateEditForm"></el-input>
                    </el-col>
                </el-row>
                <div v-show="advanced">
                    <h2 class="section-title">标记尺</h2>
                    <el-row :gutter="10" class="mb-4">
                        <el-col :xs="24" :sm="24">
                            <el-input v-model="editForm.rulerName" placeholder="文本" clearable
                                @input="validateEditForm"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="24">
                            <el-input v-model.number="editForm.rulerBottom" type="number" min="50" max="250"
                                placeholder="标记尺底部（%）" clearable @input="validateEditForm"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="24">
                            <el-input v-model.number="editForm.rulerTop" type="number" min="50" max="250"
                                placeholder="标记尺顶部（%）" clearable @input="validateEditForm"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="24">
                            <el-input v-model.number="editForm.rulerOffset" type="number" min="50" max="250"
                                placeholder="标记尺相对立绘中心偏移量（px）" clearable @input="validateEditForm"></el-input>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="pattern-selector mb-4">
                    <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                        accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                        :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                        :file-list="currentImage" style="padding-bottom: 2rem" :limit="1">
                        <el-icon>
                            <Plus />
                        </el-icon>
                    </el-upload>
                    <el-text type="info" class="ml-2 text-sm">支持JPG/PNG格式，不超过10MB</el-text>
                </div> -->
                <el-button type="primary" @click="submitEdit" :disabled="!editFormValid">
                    确定
                </el-button>
            </el-form>
        </el-dialog>
        <el-row>
            <el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6">
                <!-- 左侧栏 -->
                <el-card shadow="hover">
                    <h2 class="section-title">添加人物</h2>
                    <el-form :model="personForm" class="mb-4">
                        <el-row :gutter="10" class="mb-4">
                            <el-col :xs="24" :sm="24">
                                <el-input v-model="personForm.name" placeholder="姓名" clearable
                                    @input="validatePersonForm"></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="24">
                                <el-input v-model.number="personForm.height" type="number" min="50" max="250"
                                    placeholder="身高（cm）" clearable @input="validatePersonForm"></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="24" style="padding-top: 1rem;">
                                <el-button type="default" @click="handleAdvanced">进阶选项</el-button>
                                <el-text style="padding-left: 0.5rem;">注：进阶选项均为非必选项</el-text>
                            </el-col>
                            <el-col :xs="24" :sm="24" v-show="advanced">
                                <el-input v-model.number="personForm.gap" type="number" min="50" max="250"
                                    placeholder="左间距（px）" clearable @input="validatePersonForm"></el-input>
                            </el-col>
                        </el-row>
                        <div v-show="advanced">
                            <h2 class="section-title">标记尺</h2>
                            <el-row :gutter="10" class="mb-4">
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model="personForm.rulerName" placeholder="文本" clearable
                                        @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerBottom" type="number" min="50" max="250"
                                        placeholder="标记尺底部（%）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerTop" type="number" min="50" max="250"
                                        placeholder="标记尺顶部（%）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerOffset" type="number" min="50" max="250"
                                        placeholder="标记尺相对立绘中心偏移量（px）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="pattern-selector mb-4">
                            <h2 class="section-title">添加立绘</h2>
                            <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                                accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                                :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                                :file-list="currentImage" style="padding-bottom: 2rem" :limit="1">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <el-text type="info" class="ml-2 text-sm">支持JPG/PNG格式，不超过10MB</el-text>
                        </div>
                        <el-button type="primary" @click="addPerson" :disabled="!personFormValid">
                            添加
                        </el-button>
                        <el-button @click="capture('#pic', '#captureResult')" type="default">生成截图</el-button>
                    </el-form>
                </el-card>
                <el-card class="mb-6" shadow="hover">
                    <h2 class="section-title">人物列表</h2>
                    <el-row :gutter="10">
                        <el-col :xs="24" :md="12" v-for="(person, index) in persons" :key="'person-' + index">
                            <el-card>
                                <p>{{ person.name }}:{{ person.height }}cm</p>
                                <el-row>
                                    <el-col :xs="24" :lg="12"><el-button type="primary" :icon="Edit"
                                            @click="editPerson(index)" /></el-col>
                                    <el-col :xs="24" :lg="12"> <el-button type="danger" :icon="Delete"
                                            @click="removePerson(index)" /></el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
                <!-- 侧边栏 -->
                <el-drawer v-model="drawerVisible" direction="ltr" size="100%">
                    <el-form :model="personForm" class="mb-4">
                        <h2 class="section-title">添加人物</h2>
                        <el-row :gutter="10" class="mb-4">
                            <el-col :xs="24" :sm="24">
                                <el-input v-model="personForm.name" placeholder="姓名" clearable
                                    @input="validatePersonForm"></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="24">
                                <el-input v-model.number="personForm.height" type="number" min="50" max="250"
                                    placeholder="身高（cm）" clearable @input="validatePersonForm"></el-input>
                            </el-col>
                            <el-col :xs="24" :sm="24" style="padding-top: 1rem;">
                                <el-button type="default" @click="handleAdvanced">进阶选项</el-button>
                                <el-text style="padding-left: 0.5rem;">注：进阶选项均为非必选项</el-text>
                            </el-col>
                            <el-col :xs="24" :sm="24" v-show="advanced">
                                <el-input v-model.number="personForm.gap" type="number" min="50" max="250"
                                    placeholder="左间距（px）" clearable @input="validatePersonForm"></el-input>
                            </el-col>
                        </el-row>
                        <div v-show="advanced">
                            <h2 class="section-title">标记尺（可选项）</h2>
                            <el-row :gutter="10" class="mb-4">
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model="personForm.rulerName" placeholder="文本" clearable
                                        @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerBottom" type="number" min="50" max="250"
                                        placeholder="标记尺底部（%）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerTop" type="number" min="50" max="250"
                                        placeholder="标记尺顶部（%）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                                <el-col :xs="24" :sm="24">
                                    <el-input v-model.number="personForm.rulerOffset" type="number" min="50" max="250"
                                        placeholder="标记尺相对立绘中心偏移量（px）" clearable @input="validatePersonForm"></el-input>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="pattern-selector mb-4">
                            <h2 class="section-title">添加立绘</h2>
                            <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                                accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                                :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                                :file-list="currentImage" style="padding-bottom: 2rem" :limit="1">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <el-text type="info" class="ml-2 text-sm">注：支持JPG/PNG格式，不超过10MB</el-text>
                        </div>
                        <el-button type="primary" @click="addPerson" :disabled="!personFormValid">
                            添加
                        </el-button>
                        <el-button @click="capture('#pic', '#captureResult')" type="default">生成截图</el-button>
                    </el-form>
                    <el-card class="mb-6" shadow="hover">
                        <h2 class="section-title">人物列表</h2>
                        <el-row :gutter="10">
                            <el-col :xs="24" :md="12" v-for="(person, index) in persons" :key="'person-' + index">
                                <el-card>
                                    <p>{{ person.name }}:{{ person.height }}cm</p>
                                    <el-button type="primary" :icon="Edit" @click="editPerson(index)" />
                                    <el-button type="danger" :icon="Delete" @click="removePerson(index)" />
                                </el-card>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-drawer>
            </el-col>
            <div style="flex: 1;" id="pic">
                <!-- <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18"> -->
                <!-- 右侧栏 -->
                <el-card shadow="hover" style="position:relative">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <h2 class="section-title">身高对比可视化</h2>
                        <p style="transform: translateY(5px);">made by world_end</p>
                    </div>
                    <!-- 坐标轴 -->
                    <div class="axis-tick" v-for="height in axisHeights" :key="height"
                        :style="{ bottom: `calc( ${height} * ${scaleRatio} )` }">
                        {{ height }}cm
                    </div>
                    <div class="visualization-container" id="visualization-container" :style="{
                        height:
                            visualizationHeight
                    }">

                        <div class="axis-dash" v-for="height in axisHeights" :key="'dash-' + height"
                            :style="{ bottom: `calc( ${height} * ${scaleRatio} )` }">
                        </div>
                        <!-- 对比条 -->
                        <div class="comparison-bar-container">
                            <div class="person-bar" v-for="(person, index) in persons" :key="'bar-person-' + index"
                                :style="{
                                    marginLeft: index > 0 ? `calc(${person.gap}px)` : '0'
                                }">
                                <div class="bar-label">
                                    <el-text size="small">{{ person.name }}:{{ person.height }}cm</el-text>
                                </div>
                                <div class="person-bar-inner" :style="{
                                    height: `calc( ${person.height} * ${scaleRatio} )`
                                }">
                                    <template v-if="person.patternType === 'image'">
                                        <img :src="person.patternValue" alt="人物图">
                                    </template>
                                    <template v-else>
                                        <el-icon :class="person.patternValue"></el-icon>
                                    </template>
                                </div>
                                <div class="ruler" v-if="person.rulerTop && person.rulerBottom" :style="{
                                    marginLeft: `calc( ${person.rulerOffset}px)`,
                                    bottom: `calc( ${person.height} * ${scaleRatio}*${person.rulerBottom}/100)`,
                                    top: `calc( ( ${person.height} * ${scaleRatio} * ( 100 - ${person.rulerTop} ) / 100 ) + 30px ) `,
                                }">
                                    <div class="top-line" />
                                    <div class="middle-line" />
                                    <div class="bottom-line" />
                                    <span class="ruler-name">
                                        {{ person.rulerName }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
                <!-- </el-col> -->
            </div>
        </el-row>
        <h2 class="section-title">关于标记尺</h2>
        <el-image src="https://img.helloworldend.top/upload/portrait.png" style="width:250px"></el-image><br>
        <el-text>标记尺如上图红框中所示，可以用于标记帽子/角/手持物等特殊部件的高度，每个人物暂时只能设置一把标记尺</el-text><br>
        <el-text><b>文本：</b>标记尺的文本内容，可随意填写</el-text><br>
        <el-text><b>标记尺底部（%）&标记尺底部（%）：</b>以人物鞋底为0%，以人物头顶为100%，需分别填写标记尺底部和顶部的百分值</el-text><br>
        <el-text><b>标记尺相对立绘中心偏移量（px）：</b>标记尺距离人物中心的像素数，标记尺在人物右侧为正值，反之为负值</el-text>
        <el-text>作为参考，例图的参数分别为：兽耳（15cm），95，100，150</el-text>
        <h2 class="section-title">更新日志</h2>
        <el-text>5/8:更新了排版格式</el-text><br>
        <el-text>11/13:（虽然过程很煎熬，但是）更新了截图功能和画布无限延长功能，之后会考虑给按钮找个更合适的位置</el-text><br>
        <el-text>11/7:更新了白底自动转透明底的功能，要求立绘有闭合的外边缘，之后会考虑做成可选项</el-text><br>
        <el-text>10/21:更新了标记尺功能以及人物列表编辑功能（暂不支持编辑图片）</el-text><br>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import { ref, getCurrentInstance, onMounted, computed, nextTick } from "vue"
import { ElMessage, useBreakpoint } from "element-plus"
import {
    User, Delete, Edit
} from '@element-plus/icons-vue'
import { Plus } from '@element-plus/icons-vue'

const title = "身高对比可视化"
const subtitle = "因为想要自定义人物形象所以手搓了一个"

const persons = ref([])
const items = ref([])
const currentPattern = ref({ type: 'icon', value: User })
const currentImage = ref([])
const editImage = ref([])
const widths = ref([])
const heights = ref([])
const uploadFile = ref()
const isCropping = ref(false)
const currentImageVisible = ref(false)
const drawerVisible = ref(false)
const editVisible = ref(false)
const WHITE_THRESHOLD = 245;
const TRANSPARENT_ALPHA = 0;
const DIRECTIONS = [[-1, 0], [1, 0], [0, -1], [0, 1]];
const captureVisible = ref(false)
const advanced = ref(false)

let windowWidth = window.innerWidth;
const visualizationHeight = windowWidth > 500 ? ref('100vh') : ref('250px')

const maxPersonHeight = computed(() => {
    if (persons.value.length === 0) return 200
    return Math.max(...persons.value.map(p => p.height))
})


// const scaleRatio = computed(() => {
//     return `calc(75vh / ${maxPersonHeight.value})`
// })
const scaleRatio = computed(() => {
    if (windowWidth > 500) {
        return `calc(75vh / ${maxPersonHeight.value})`;
    } else {
        return `calc(250px / ${maxPersonHeight.value})`;
    }
});

const axisHeights = computed(() => {
    const maxH = maxPersonHeight.value
    const step = 20
    const count = Math.ceil(maxH / step) + 1
    return Array.from({ length: count }, (_, i) => i * step)
        .filter(h => h <= maxH)
})


const personForm = ref({
    name: '',
    height: null,
    gap: null,
    rulerOffset: null,
    rulerTop: null,
    rulerBottom: null,
    rulerName: null,
    image: null
})

const editForm = ref({
    name: '',
    height: null,
    gap: null,
    rulerOffset: null,
    rulerTop: null,
    rulerBottom: null,
    rulerName: null,
    image: null,
    index: null
})

// const axisHeights = Array.from({ length: 12 }, (_, i) => 220 - i * 20)

const personFormValid = ref(false)
const itemFormValid = ref(false)
const editFormValid = ref(false)

const validatePersonForm = () => {
    personFormValid.value = !!(
        personForm.value.name.trim() &&
        personForm.value.height >= 0 &&
        currentPattern.value
    )
}


const validateEditForm = () => {
    editFormValid.value = !!(
        editForm.value.name.trim() &&
        editForm.value.height >= 0 &&
        currentPattern.value
    )
}

const validateItemForm = () => {
    itemFormValid.value = !!(
        itemForm.value.name.trim() &&
        itemForm.value.height >= 0
    );
};

const handlePreview = () => {
    currentImageVisible.value = true
}

const handleRemove = () => {
    uploadFile.value = null;
    $('.el-upload').css('display', 'flex');
    ElMessage.info('人物已删除')
}


const cropTransparentEdges = (image) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const width = image.width;
    const height = image.height;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(image, 0, 0);

    let imageData = ctx.getImageData(0, 0, width, height);
    let data = imageData.data;

    const visited = new Uint8Array(width * height);
    const queue = [];

    for (let x = 0; x < width; x++) {
        checkAndAddSeed(x, 0, width, height, data, visited, queue);
        checkAndAddSeed(x, height - 1, width, height, data, visited, queue);
    }
    for (let y = 1; y < height - 1; y++) {
        checkAndAddSeed(0, y, width, height, data, visited, queue);
        checkAndAddSeed(width - 1, y, width, height, data, visited, queue);
    }

    while (queue.length > 0) {
        const [x, y] = queue.shift();
        const pixelIndex = y * width + x;

        for (const [dx, dy] of DIRECTIONS) {
            const nx = x + dx;
            const ny = y + dy;

            if (nx >= 0 && nx < width && ny >= 0 && ny < height) {
                const newPixelIndex = ny * width + nx;
                if (!visited[newPixelIndex] && isPixelWhite(data, newPixelIndex * 4)) {
                    visited[newPixelIndex] = 1;
                    queue.push([nx, ny]);
                }
            }
        }
    }

    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const pixelIndex = y * width + x;
            const dataIndex = pixelIndex * 4;
            if (visited[pixelIndex]) {
                data[dataIndex + 3] = TRANSPARENT_ALPHA;
            }
        }
    }

    ctx.putImageData(imageData, 0, 0);


    function checkAndAddSeed(x, y, width, height, data, visited, queue) {
        const pixelIndex = y * width + x;
        const dataIndex = pixelIndex * 4;
        if (!visited[pixelIndex] && isPixelWhite(data, dataIndex)) {
            visited[pixelIndex] = 1;
            queue.push([x, y]);
        }
    }

    function isPixelWhite(data, dataIndex) {
        const r = data[dataIndex];
        const g = data[dataIndex + 1];
        const b = data[dataIndex + 2];
        const a = data[dataIndex + 3];
        return r >= WHITE_THRESHOLD && g >= WHITE_THRESHOLD && b >= WHITE_THRESHOLD && a > 0;
    }

    imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    data = imageData.data;
    let top = canvas.height, bottom = 0, left = canvas.width, right = 0;
    let hasNonTransparent = false;

    for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
            const index = (y * canvas.width + x) * 4;
            const alpha = data[index + 3];

            if (alpha > 0) {
                hasNonTransparent = true;
                top = Math.min(top, y);
                bottom = Math.max(bottom, y);
                left = Math.min(left, x);
                right = Math.max(right, x);
            }
        }
    }


    if (!hasNonTransparent) {
        return new Promise(resolve => {
            image.onload = () => resolve(image);
            image.src = image.src;
        });
    }


    const cropWidth = right - left + 1;
    const cropHeight = bottom - top + 1;

    widths.value.push(cropWidth);
    heights.value.push(cropHeight);

    const cropCanvas = document.createElement('canvas');
    cropCanvas.width = cropWidth;
    cropCanvas.height = cropHeight;
    const cropCtx = cropCanvas.getContext('2d');

    cropCtx.drawImage(
        canvas,
        left, top, cropWidth, cropHeight,
        0, 0, cropWidth, cropHeight
    );

    return new Promise((resolve) => {
        const croppedImage = new Image();
        croppedImage.onload = () => resolve(croppedImage);
        croppedImage.src = cropCanvas.toDataURL('image/png');
    });
};

const handleImageUpload = async (file) => {
    if (!file.raw.type.startsWith('image/')) {
        ElMessage.error('请选择图片文件（JPG/PNG格式）');
        return;
    }
    if (file.raw.size / 1024 / 1024 > 10) {
        ElMessage.error('图片大小不能超过10MB');
        return;
    }

    try {
        isCropping.value = true;

        const image = new Image();
        const reader = new FileReader();

        await new Promise((resolve, reject) => {
            reader.onload = (e) => {
                image.src = e.target.result;
                image.onload = resolve;
                image.onerror = reject;
            };
            reader.readAsDataURL(file.raw);
        });

        const croppedImage = await cropTransparentEdges(image);

        currentPattern.value = { type: 'image', value: croppedImage.src };
        validatePersonForm();
        ElMessage.success('图片上传并裁剪成功');
    } catch (error) {
        ElMessage.error('图片处理失败，请重试');
        console.error('图片处理错误:', error);
    } finally {
        isCropping.value = false;
    }
};

const handleFileChange = (file, newFileList) => {
    handleImageUpload(file);
    currentImage.value = newFileList;
    uploadFile.value = file.raw;
    if (currentImage.value.length > 0) {
        $('.el-upload').css('display', 'none');
    }
};


const addPerson = () => {
    // if (persons.value.length >= 10) {
    //     ElMessage.warning('最多只能添加10人')
    //     return
    // }
    persons.value.push({
        ...personForm.value,
        patternType: currentPattern.value.type,
        image: currentImage.value,
        patternValue: currentPattern.value.type === 'icon'
            ? currentPattern.value.value
            : currentPattern.value.value
    })
    personForm.value = {
        name: '',
        height: null,
        gap: null,
        rulerOffset: null,
        rulerTop: null,
        rulerBottom: null,
        rulerName: null,
        image: null
    }

    currentPattern.value = { type: 'icon', value: User }
    validatePersonForm()
    drawerVisible.value = false;
    ElMessage.success('人物添加成功')
    nextTick(() => {
        setWidth('#visualization-container');
    });
}

const addItem = () => {
    if (items.value.length >= 3) {
        ElMessage.warning('最多只能添加3个物品');
        return;
    }
    items.value.push({ ...itemForm.value });
    itemForm.value.name = '';
    itemForm.value.height = null;
    validateItemForm();
    ElMessage.success('物品添加成功');
};


const removePerson = (index) => {
    persons.value.splice(index, 1)
    ElMessage.info('人物删除成功')
    nextTick(() => {
        setWidth('#visualization-container');
    });
}

const deepCopy = (original, copy) => {
    const deepCopiedValue = JSON.parse(JSON.stringify(original));
    copy.value = deepCopiedValue;
};

const editPerson = (index) => {
    deepCopy(persons.value[index], editForm);
    editForm.value.index = index;
    currentImage.value = editForm.value.image
    editVisible.value = true;
}

const submitEdit = () => {
    const index = editForm.value.index;
    persons.value[index] = editForm.value;
    editVisible.value = false;
    ElMessage.info('人物编辑成功')
}

const handleAdvanced = () => {
    advanced.value = advanced.value == true ? false : true;
}

function setWidth(parentSelector) {
    const parent = typeof parentSelector === 'string'
        ? document.querySelector(parentSelector)
        : parentSelector;

    if (!parent) {
        console.warn('父容器不存在');
        return;
    }

    const children = [];
    Array.from(parent.children).filter(child =>
        Array.from(child.children).forEach(grandchild => {
            if (grandchild.nodeType === 1 && child.classList.contains('comparison-bar-container')) {
                children.push(grandchild);
            }
        }));

    if (children.length === 0) {
        parent.style.width = 'auto';
        return;
    }

    let totalWidth = 0;
    children.forEach(child => {
        if (window.getComputedStyle(child).display === 'none') return;

        const offsetWidth = child.offsetWidth;

        const computedStyle = window.getComputedStyle(child);
        const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
        const marginRight = parseFloat(computedStyle.marginRight) || 0;

        totalWidth += offsetWidth + marginLeft + marginRight;
    });

    const redundant = 2;
    parent.style.width = `${totalWidth + redundant + 100}px`;

}

const capture = (selector1, selector2) => {
    captureVisible.value = true;
    nextTick(() => {
        var element = document.querySelector(selector1);
        //要显示图片的img标签
        var image = document.querySelector(selector2);
        //调用html2image方法
        const mark = document.querySelector('.mask');
        if (element) {
            if (mark) {
                var bgColor = getComputedStyle(mark).backgroundColor;
                var text = mark.textContent;
                const arrTextNode = text.split('').map(char => {
                    var span = document.createElement('span');
                    span.textContent = char;
                    span.style.backgroundColor = bgColor;
                    span.style.color = "#ffffff";
                    return span;
                });
                mark.replaceWith.apply(mark, arrTextNode);
            }
            html2image(element, image);
        }
    });


    function html2image(element, image) {
        const options = {
            scale: 3,
            useCORS: true,
            logging: false,
            width: element.offsetWidth,
            height: element.offsetHeight,
            dpi: 300,
            letterRendering: true,
        };
        html2canvas(element, options).then(function (canvas) {
            var imageData = canvas.toDataURL(1);
            //此时图片已经可以显示了
            image.src = imageData;
        });
    }

}
</script>
<style scoped>
.radius {
    border: 1px solid var(--el-border-color);
    border-radius: 0;
    padding: 2rem;
}

p {
    color: var(--el-text-color-regular);
    font-size: 1rem;
}

.main-title {
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    margin: 20px 0 30px;
}

.section-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 15px;
    color: #333;
}

.sub-title {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 10px;
    color: #666;
}

.pattern-selector {
    margin: 20px 0;
}

.preview-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pattern-preview {
    width: 60px;
    height: 60px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.preview-icon {
    font-size: 2rem;
}

.icon-selector {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.list-item-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 10px;
}

.item-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pattern-thumbnail {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pattern-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.color-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.item-details {
    line-height: 1.5;
}

.delete-btn {
    color: #F56C6C;
}


.visualization-container {
    position: relative;
    height: 100%;
    min-height: 250px;
    max-height: 80vh;
    margin: 20px 0 20px 50px;
    padding-bottom: 20px;
    background:
        linear-gradient(to top, #e5e7eb 100%, transparent 100%) left / 1.5px 100% no-repeat;
    overflow-x: auto;
    overflow-y: hidden;
}


.axis-tick {
    position: absolute;
    left: 20px;
    transform: translateY(-30px);
    font-size: 0.875rem;
    color: #666;
    z-index: 2;

}

.axis-dash {
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background: repeating-linear-gradient(to right,
            #e5e7eb,
            #e5e7eb 5px,
            transparent 5px,
            transparent 10px);
}


.comparison-bar-container {
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    padding: 0 40px;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: center;
}

.person-bar,
.item-bar {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
}

.person-bar-inner {
    width: auto;
    border-radius: 4px 4px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    z-index: 3;
}

.person-bar-inner img {
    height: 100%;
    width: auto;
    object-fit: contain;
}

.item-bar-inner {
    width: 40px;
    border-radius: 4px 4px 0 0;
    transition: all 0.3s;
    z-index: 3;
}

.bar-label {
    text-align: center;
    line-height: 1.5;
    border-bottom: 1px solid slategray;
}

.dash-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
}

.ruler {
    position: absolute;
    width: 20px;
    box-sizing: border-box;
}

.el-drawer__body {
    padding: 20px;
}

.top-line {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: slategray;
    z-index: 4;
}

.bottom-line {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: slategray;
    z-index: 4;
}

.middle-line {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    background: slategray;
    z-index: 4;
}

.ruler-name {
    position: absolute;
    left: 20px;
    top: 50%;
    font-size: 12px;
    color: slategray;
    white-space: nowrap;
    z-index: 4;
}
</style>